module.exports = __webpack_public_path__ + "static/media/news4-3.136ba87a.jpg";